import { PeriodKpi } from "@/api/periodData";

export const STAT_LABELS: Record<keyof Omit<PeriodKpi, "period" | "teamId" | "matchId">, string> = {
    goals: "Goals",
    shots: "Shots",
    shotsOnGoal: "Shots on Goal",
    shotsWithScreen: "Shots w/ Screen",
    saves: "Saves",
    expectedGoals: "xGoals",
    faceoffWins: "Faceoff Wins",
    faceoffCount: "Faceoff Count",
    successfulPasses: "Successful Passes",
    allPasses: "All Passes",
    totalPassDistance: "Pass Distance (m)",
    forwardPassDistance: "Fwd Pass Dist. (m)",
    puckContestsWon: "Puck Battles Won",
    puckContestsLost: "Puck Battles Lost",
    totalPuckContests: "Total Puck Battles",
    distanceTravelled: "Distance (m)",
    distanceTravelledWithPuck: "Distance w/ Puck (m)",
    forwardDistanceTravelledWithPuck: "Fwd Dist. w/ Puck (m)",
    accelerations: "Accelerations",
    highAccelerations: "High Accelerations",
    decelerations: "Decelerations",
    corsiForPercentage: "Corsi For %",
    fenwickForPercentage: "Fenwick For %",
    pdo: "PDO",
    powerplayGoals: "PowerPlay Goals",
    powerplayCount: "PowerPlay Count",
    penaltyKillGoalsAgainst: "PenaltyKill Goals Against",
    penaltyKillCount: "PenaltyKill Count",
};

export interface StatGroup {
    label: string;
    fields: (keyof Omit<PeriodKpi, "period" | "teamId" | "matchId">)[];
}

export const STAT_GROUPS: StatGroup[] = [
    {
        label: "Scoring & Goalkeeping",
        fields: ["goals", "shots", "shotsOnGoal", "shotsWithScreen", "saves", "expectedGoals"],
    },
    {
        label: "Faceoffs",
        fields: ["faceoffWins", "faceoffCount"],
    },
    {
        label: "Passing",
        fields: ["successfulPasses", "allPasses", "totalPassDistance", "forwardPassDistance"],
    },
    {
        label: "Puck Battles",
        fields: ["puckContestsWon", "puckContestsLost", "totalPuckContests"],
    },
    {
        label: "Physical",
        fields: [
            "distanceTravelled",
            "distanceTravelledWithPuck",
            "forwardDistanceTravelledWithPuck",
            "accelerations",
            "highAccelerations",
            "decelerations",
        ],
    },
    {
        label: "Advanced",
        fields: ["corsiForPercentage", "fenwickForPercentage", "pdo"],
    },
    {
        label: "Powerplay & Penalty Kill",
        fields: ["powerplayGoals", "powerplayCount", "penaltyKillGoalsAgainst", "penaltyKillCount"],
    },
];

export const formatValue = (v: number, field: string): string => {
    const percentFields = ["corsiForPercentage", "fenwickForPercentage"];
    const decimalFields = [
        "expectedGoals",
        "pdo",
        "totalPassDistance",
        "forwardPassDistance",
        "distanceTravelled",
        "distanceTravelledWithPuck",
        "forwardDistanceTravelledWithPuck",
    ];
    if (percentFields.includes(field)) return `${(v * 100).toFixed(1)}%`;
    if (decimalFields.includes(field)) return v.toFixed(1);
    return Number.isInteger(v) ? String(v) : v.toFixed(1);
};

export const getPeriodLabel = (period: number): string => (period === 4 ? "OT" : `P${period}`);
export const getPeriodTitle = (period: number): string => (period === 4 ? "Overtime" : `Period ${period}`);
